import { Injectable } from '@angular/core';

import { BarChartData } from '../models/bar-chart.model';
import { barChartOptions } from '../options/bar-chart.options';
import { barChartTimeOptions } from '../options/bar-chart-time.options';

import * as Chart from 'chart.js';

@Injectable()
export class BarChartService {

  constructor() { }

  generateBarChart(chartCanvas: any, chartLabels: string[], datasets: BarChartData[], chartTypeOptions = 'default', displayLegend: boolean = true, legendPosition: string = 'top') {
    const barChartBaseOptions: any = chartTypeOptions === 'default' ? barChartOptions : barChartTimeOptions;

    // Disable stacked mode.
    barChartBaseOptions.scales.xAxes[0].stacked = false;
    barChartBaseOptions.scales.yAxes[0].stacked = false;

    // Check if the legend will be displayed.
    barChartBaseOptions.legend.display = displayLegend;

    // Defines legend position.
    barChartBaseOptions.legend.position = legendPosition;

    this.generateChart(chartCanvas, chartLabels, datasets, barChartBaseOptions);
  }

  generateStackedBarChart(chartCanvas: any, chartLabels: string[], datasets: BarChartData[], chartTypeOptions = 'default', displayLegend: boolean = true, legendPosition: string = 'top') {
    const barChartBaseOptions: any = chartTypeOptions === 'default' ? barChartOptions : barChartTimeOptions;

    // Enable stacked mode.
    barChartBaseOptions.scales.xAxes[0].stacked = true;
    barChartBaseOptions.scales.yAxes[0].stacked = true;

    // Check if the legend will be displayed.
    barChartBaseOptions.legend.display = displayLegend;

    // Defines legend position.
    barChartBaseOptions.legend.position = legendPosition;

    this.generateChart(chartCanvas, chartLabels, datasets, barChartBaseOptions);
  }

  private generateChart(chartCanvas: any, chartLabels: string[], datasets: BarChartData[], chartOptions: any) {
    const chart = new Chart(chartCanvas, {
      // The type of chart we want to create.
      type: 'bar',

      // The data for our dataset
      data: {
        labels: chartLabels,
        datasets: datasets
      },

      // Configuration options go here
      options: chartOptions
    });
  }
}
